export default __webpack_public_path__ + "static/media/lightbulb-icon.efd5ee5c.svg";